(() => {
  const read = selector => {
    const node = document.querySelector(selector);
    return node ? JSON.parse(node.textContent) : null;
  };
  const settings = read('[data-op-couch-runtime]');
  if (!settings) return;
  const text = settings.text;
  const cartStyles = ".op-coverage-cart-active .upcart-public-upsell,.op-coverage-cart-active .upcart-public-component-upsells,.op-coverage-cart-active [data-op-bundle-cart-offers],.op-coverage-cart-active [data-op-cart-offers]{display:none!important}.op-coverage-cart{border-top:1px solid #e4e4e6;padding:24px 20px}.op-coverage-cart h3{font:inherit;font-size:20px;font-weight:750;line-height:1.35;text-align:center;margin:0 0 20px}.op-coverage-cart__card{display:flex;gap:12px;align-items:center;background:#f5f5f5;padding:13px;border-radius:10px;margin-bottom:12px}.op-coverage-cart__card>img{width:84px;height:84px;object-fit:cover;border-radius:7px;flex-shrink:0}.op-coverage-cart__content{flex:1;min-width:0}.op-coverage-cart h4{font:inherit;font-size:14px;font-weight:700;line-height:1.4;margin:0 0 5px}.op-coverage-cart p{font-size:13px;margin:4px 0 7px}.op-coverage-cart select{display:block;width:100%;min-height:40px;border:1px solid #bcbcc2;border-radius:6px;padding:6px;color:#252530;background:#fff;font:inherit;font-size:12px}.op-coverage-cart button{display:block;width:100%;min-height:40px;margin-top:8px;padding:8px;border:0;border-radius:7px;background:#123d36;color:#fff;font:inherit;font-size:13px;font-weight:750;cursor:pointer}.op-coverage-cart button:disabled{opacity:.5;cursor:default}.op-coverage-cart__error{color:#a81d2f}@media(max-width:390px){.op-coverage__tile{font-size:12px}.op-coverage__piece{padding:11px}.op-coverage__fields{gap:8px}.op-coverage__fields .op-coverage__quantity{flex-basis:108px;min-width:108px}.op-coverage__stepper input{width:38px}}\n/* Cam's follow-up: neutral choices, compact benefits, complete checkout. */\n.op-coverage{margin:16px 0 18px}\n.op-coverage__options{padding-top:10px;align-items:stretch}\n.op-coverage__choice{display:flex}\n.op-coverage__choice>input{top:12px;accent-color:#24242b}\n.op-coverage__tile{position:relative;width:100%;min-height:130px;gap:4px;padding:42px 10px 8px;border-color:#d4d5d7;color:#24242b;background:#fff;box-shadow:none}\n.op-coverage__tile svg{width:44px;height:22px;flex-shrink:0}\n.op-coverage__choice--full .op-coverage__tile{border-color:#d4d5d7;color:#24242b;background:#fff;box-shadow:none}\n.op-coverage__choice>input:checked+.op-coverage__tile{border:3px solid #24242b;padding:41px 9px 7px;background:#f8f8f8;box-shadow:none}\n.op-coverage__choice>input:checked+.op-coverage__tile::after{top:10px;right:8px;background:#24242b}\n.op-coverage__popular{position:absolute;top:-11px;left:50%;transform:translateX(-50%);padding:4px 11px;border-radius:20px;background:#30c2a7;color:#123b34;font-size:10px;font-weight:800;line-height:1.2;white-space:nowrap}\n.op-coverage__detail{display:block;font-size:11px;line-height:1.35;font-weight:450;max-width:190px}\n.op-coverage__benefit{display:flex;align-items:center;justify-content:center;gap:4px;font-size:11px;font-weight:650;line-height:1.3;margin-top:2px}\n.op-coverage__benefit i,.op-coverage__benefits i{font-style:normal;color:#30c2a7;font-weight:850;flex-shrink:0}\n.op-coverage__pieces{margin-top:12px}\n.op-coverage__piece{padding:10px 12px;margin-bottom:8px}\n.op-coverage__piece h3{font-size:14px;margin:0 0 5px}\n.op-coverage__benefits{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:4px 8px;list-style:none;padding:0;margin:0 0 8px;font-size:10.5px;font-weight:700;line-height:1.25;color:#3c3c45}\n.op-coverage__benefits li{display:flex;align-items:start;gap:4px;min-width:0}.op-coverage__check{color:#30c2a7;flex:0 0 14px;margin-top:0}.op-coverage__benefits--shared{display:none}.op-coverage__universal{position:absolute;left:0;right:0;top:28px;text-align:center;font-size:9px;line-height:1.2;font-weight:700;color:#45454d}\n.op-coverage__fields{gap:8px;flex-wrap:nowrap}\n.op-coverage__fields>label{font-size:11px;min-width:0}\n.op-coverage__fields select{min-height:38px;margin-top:4px;padding:6px;font-size:12px}\n.op-coverage__fields .op-coverage__quantity{min-width:102px;flex:0 0 102px}\n.op-coverage__stepper{height:38px;margin-top:4px}\n.op-coverage__stepper button{width:30px;height:36px;font-size:18px}\n.op-coverage__stepper input{width:40px;font-size:13px}\n.op-coverage__unit-price{font-size:11px;margin:6px 0 0}\n.op-coverage__total{align-items:center;font-size:15px;padding:5px 0 0;margin:12px 0 0}\n.op-coverage__total-label{display:flex;align-items:center;flex-wrap:wrap;gap:5px 8px}\n.op-coverage__saving{display:inline-block;font-size:10px;font-weight:750;line-height:1.3;padding:4px 7px;border-radius:5px;background:#e9f8f5;color:#175347;white-space:nowrap}\n.op-coverage__checkout{display:none;margin-top:10px}\n[data-op-coverage-full] .op-coverage__checkout{display:block}\n.op-coverage__checkout [inert]{opacity:.55}\n[data-op-pd] [data-op-atc]{display:flex;align-items:center;justify-content:center;gap:10px}\n.op-coverage__cart-icon{width:22px;height:22px;flex-shrink:0}\n[data-op-pd] .shopify-payment-button__more-options{display:none!important}\n[data-op-pd] shopify-accelerated-checkout{--shopify-accelerated-checkout-button-block-size:52px;--shopify-accelerated-checkout-button-border-radius:var(--pg-radius-btn,10px)}\n.op-coverage__payments{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:5px;list-style:none;margin:12px 0 0;padding:0}\n.op-coverage__payments li{display:flex;margin:0;padding:0}\n.op-coverage__payment-icon{width:35px;height:22px}\n@media(max-width:480px){.op-coverage__tile{min-height:130px;padding-left:7px;padding-right:7px;font-size:13px}.op-coverage__detail{font-size:10.5px;line-height:1.25}.op-coverage__piece{padding:10px}.op-coverage__fields{gap:6px}.op-coverage__fields .op-coverage__quantity{flex-basis:90px;min-width:90px}.op-coverage__stepper button{width:27px}.op-coverage__stepper input{width:34px}.op-coverage__benefits{gap:4px 6px;font-size:10px}.op-coverage__benefits--shared{display:grid;margin:0 0 10px;padding:0 2px}.op-coverage__piece .op-coverage__benefits{display:none}.op-coverage__piece h3{font-size:12.5px}.op-coverage__fields select{min-height:40px}.op-coverage__stepper{height:40px}.op-coverage__stepper button{height:38px}.op-coverage__total{font-size:14px}}\n.op-coverage-cart button,.upcart-public-upsell button,.upcart-public-component-upsells button,[data-op-bundle-cart-offers] button,[data-op-cart-offers] button{background:#30c2a7!important;color:#123b34!important;border-color:#30c2a7!important}\n\n\n.op-rv__illustration-caption{font-size:11px;line-height:1.4;color:#596670;background:#f7faf9;padding:8px 16px;margin:0;border-bottom:1px solid #e6ebe8}\n.op-protector-note{display:block;max-width:600px;margin:0 auto 32px;padding:0;border:0;background:transparent}.op-protector-note img{display:block;width:100%;max-width:none;height:auto;aspect-ratio:1;border-radius:12px}\n\n.op-pd__gal:has([data-op-thumb=\"3\"].is-on):has(img[src*=\"op-optional-protectors-details-square-20261102\"]) .op-pd__count{display:none}\n";
  const route = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
  const minimum = input => Number(input.min || 1);
  const count = input => Math.max(minimum(input), Math.min(99, Math.floor(Number(input.value) || 0)));
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const imageUrl = (color, mode, width = 1500) => `${settings.images[String(color).toLowerCase() + '-' + mode]}&width=${width}`;
  const mergeItems = items => {
    const result = [];
    items.forEach(item => {
      const found = result.find(other => other.id === item.id && JSON.stringify(other.properties || {}) === JSON.stringify(item.properties || {}));
      if (found) found.quantity += item.quantity;
      else result.push({...item});
    });
    return result;
  };
  function initCoverage(root) {
    const box = root.querySelector('[data-op-coverage]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-op-product-json]').textContent);
    const cfg = JSON.parse(box.querySelector('[data-op-coverage-config]').textContent);
    const choices = [...box.querySelectorAll('[name="op-coverage-' + cfg.section + '"]')];
    const panels = box.querySelector('[data-op-coverage-pieces]');
    const seatSize = box.querySelector('[data-op-coverage-seat-size]');
    const seatColor = box.querySelector('[data-op-coverage-seat-color]');
    const back = box.querySelector('[data-op-coverage-back]');
    const arms = box.querySelector('[data-op-coverage-arms]');
    const quantities = [...box.querySelectorAll('[data-op-piece-quantity]')];
    const atc = root.querySelector('[data-op-atc]');
    const label = root.querySelector('[data-op-atc-label]');
    const form = root.querySelector('.op-pd__form');
    const fullCheckout = root.querySelector('[data-op-full-checkout]');
    const price = root.querySelector('[data-op-price]');
    const error = box.querySelector('[data-op-coverage-error]');
    const caption = root.querySelector('[data-op-coverage-caption]');
    let busy = false;
    let full = false;
    const seat = () => data.variants.find(v => v.options[0] === seatSize.value && v.options[1] === seatColor.value);
    const accessory = (kind, select) => cfg[kind].find(v => String(v.id) === select.value);
    function chosenPieces() {
      const variants = [seat(), accessory('back', back), accessory('arms', arms)];
      if (variants.some((v, i) => count(quantities[i]) > 0 && (!v || !v.available))) throw new Error(text.unavailable);
      return variants.map((variant, i) => ({id: variant?.id, quantity: count(quantities[i]), price: variant?.price || 0}));
    }
    const coverageKind = pieces => pieces[1].quantity > 0 && pieces[2].quantity > 0 ? 'full' : 'custom';
    function currentSeatColor() {
      const v = data.variants.find(v => String(v.id) === root.querySelector('[data-op-vid]').value);
      return v?.options[1] || 'White';
    }
    function refreshImage(force = false) {
      const color = full ? seatColor.value : currentSeatColor();
      const hero = root.querySelector('[data-op-coverage-hero]');
      if (hero) {
        hero.src = imageUrl(color, full ? 'full' : 'seat');
        hero.srcset = [600,900,1200,1500].map(width => imageUrl(color, full ? 'full' : 'seat', width) + ' ' + width + 'w').join(', ');
        hero.alt = color + ' — ' + (full ? text.full : text.seat);
      }
      data.variants.forEach(v => {
        if (!v.featured_media || !settings.images[String(v.options[1]).toLowerCase() + '-seat']) return;
        const image = root.querySelector('[data-media-id="' + v.featured_media.id + '"] img');
        if (!image || image === hero) return;
        const url = imageUrl(v.options[1], 'seat');
        if (image.src !== url) { image.src = url; image.removeAttribute('srcset'); image.alt = v.options[1] + ' — ' + text.seat; }
        const slideIndex = [...image.closest('[data-op-slides]').children].indexOf(image.closest('figure'));
        const colorThumb = root.querySelector('[data-op-thumb="' + slideIndex + '"] img');
        if (colorThumb) { colorThumb.src = imageUrl(v.options[1], 'seat', 180); colorThumb.removeAttribute('srcset'); }
      });
      const thumb = root.querySelector('[data-op-thumb="0"] img');
      if (thumb) { thumb.src = imageUrl(color, full ? 'full' : 'seat', 180); thumb.removeAttribute('srcset'); }
      const backColor = accessory('back', back)?.color;
      const armColor = accessory('arms', arms)?.color;
      caption.hidden = !(full && (backColor !== color || armColor !== color));
      if (!caption.hidden) setText(caption, text.preview.replace('__COVERAGE_COLOR__', color));
      if (force) {
        const slides = root.querySelector('[data-op-slides]');
        if (slides) slides.scrollTo({left: 0, behavior: 'auto'});
      }
    }
    function sync() {
      root.toggleAttribute('data-op-coverage-full', full);
      panels.hidden = !full;
      choices.forEach(input => input.setAttribute('aria-expanded', String(input.value === 'full' && full)));
      if (!full) { refreshImage(); return; }
      quantities.forEach(input => { input.value = count(input); });
      try {
        const pieces = chosenPieces();
        if (fullCheckout) {
          const kind = coverageKind(pieces);
          const updateField = (input, value) => {
            const next = String(value);
            if (input.value !== next) { input.value = next; input.dispatchEvent(new Event('change', {bubbles: true})); }
          };
          updateField(fullCheckout.elements.namedItem('properties[_op_coverage]'), kind);
          pieces.forEach((piece, i) => {
            if (i > 0) {
              fullCheckout.querySelectorAll('[name^="shopify-additional-items[' + i + ']"]').forEach(input => { input.disabled = piece.quantity === 0; });
              updateField(fullCheckout.elements.namedItem('shopify-additional-items[' + i + '][properties]'), JSON.stringify([{key: '_op_coverage', value: kind}]));
            }
            ['id', 'quantity'].forEach(key => {
              const name = i === 0 ? key : 'shopify-additional-items[' + i + '][' + key + ']';
              const input = fullCheckout.elements.namedItem(name);
              updateField(input, piece[key] ?? '');
            });
          });
          fullCheckout.inert = busy;
        }
        const total = pieces.reduce((sum, item) => sum + item.price * item.quantity, 0);
        setText(price, money(total));
        setText(box.querySelector('[data-op-coverage-total]'), money(total));
        setText(label, busy ? text.adding : text.addFull);
        atc.disabled = busy;
        error.hidden = true;
        ['seat', 'back', 'arms'].forEach((kind, i) => setText(box.querySelector('[data-op-piece-price="' + kind + '"]'), money(pieces[i].price)));
      } catch (problem) {
        if (fullCheckout) fullCheckout.inert = true;
        atc.disabled = true;
        setText(label, text.unavailable);
        error.hidden = false;
        setText(error, problem.message);
      }
      refreshImage();
    }
    choices.forEach(input => input.addEventListener('change', () => {
      full = input.value === 'full' && input.checked;
      if (!full) {
        root.removeAttribute('data-op-coverage-full');
        const source = root.querySelector('[data-op-opt]');
        if (source) source.dispatchEvent(new Event('change', {bubbles: true}));
      }
      sync();
      refreshImage(true);
    }));
    box.querySelectorAll('[data-op-piece-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(minimum(input), Math.min(99, count(input) + Number(button.dataset.opPieceStep)));
      sync();
    }));
    seatColor.addEventListener('change', () => {
      [back, arms].forEach((select, i) => {
        const item = cfg[i === 0 ? 'back' : 'arms'].find(v => v.color === seatColor.value);
        if (item) select.value = item.id;
      });
    });
    root.addEventListener('change', event => {
      if (event.target.closest('[data-op-coverage]') || event.target.closest('[data-op-opt], [data-cover-row], [data-bundle-options]')) sync();
    });
    box.addEventListener('input', sync);
    async function purchase(event) {
      if (!full) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || atc.disabled) return;
      let pieces;
      try { pieces = chosenPieces(); } catch (problem) { sync(); return; }
      busy = true;
      sync();
      try {
        const group = 'full-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
        const kind = coverageKind(pieces);
        const items = mergeItems(pieces.filter(piece => piece.quantity > 0).map(({id, quantity}) => ({id, quantity, properties: {_op_coverage: kind, _op_coverage_set: group}})));
        const response = await fetch(route + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || text.cartError);
        if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        else location.assign(route + 'cart');
        document.dispatchEvent(new CustomEvent('op:coverage-cart-changed'));
      } catch (problem) {
        error.hidden = false;
        setText(error, problem.message);
      } finally {
        busy = false;
        const message = error.hidden ? null : error.textContent;
        sync();
        if (message) { error.hidden = false; setText(error, message); }
      }
    }
    root.addEventListener('click', event => { if (event.target.closest('[data-op-atc]')) purchase(event); }, true);
    root.addEventListener('submit', event => { if (event.target === form) purchase(event); }, true);
    sync();
  }
  const eligibleIds = new Set(settings.plushIds.map(Number));
  function cartContext(cart) {
    const eligible = cart.items.some(item => eligibleIds.has(Number(item.product_id)));
    const hasBack = cart.items.some(item => Number(item.product_id) === settings.backId);
    const hasArms = cart.items.some(item => Number(item.product_id) === settings.armsId);
    const full = cart.items.some(item => item.properties?._op_coverage === 'full') || (hasBack && hasArms);
    return {eligible, full, hasBack, hasArms};
  }
  let catalogPromise;
  const handles = ['couch-backrest-skin', 'stretch-sofa-arm-covers-2-pack', 'plush-donut-bolster-pet-bed', 'striped-flannel-throw-blanket', 'plush-throw-pillowcase'];
  function catalog() {
    if (!catalogPromise) catalogPromise = Promise.all(handles.map(async handle => {
      const response = await fetch(route + 'products/' + handle + '.js');
      if (!response.ok) throw new Error(text.cartError);
      return response.json();
    })).catch(error => { catalogPromise = null; throw error; });
    return catalogPromise;
  }
  function node(tag, className, value) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (value !== undefined) el.textContent = value;
    return el;
  }
  function card(product, currency) {
    const isBack = Number(product.id) === settings.backId;
    const isArms = Number(product.id) === settings.armsId;
    const title = isBack ? text.back : isArms ? text.arms : product.title;
    const article = node('article', 'op-coverage-cart__card');
    const image = node('img');
    image.src = isBack ? settings.backImage : product.featured_image;
    image.alt = title; image.width = 84; image.height = 84; image.loading = 'lazy';
    article.appendChild(image);
    const content = node('div', 'op-coverage-cart__content');
    content.appendChild(node('h4', '', title));
    const price = node('p'); content.appendChild(price);
    const select = node('select'); select.setAttribute('aria-label', title + ' — ' + text.color);
    const allowed = isBack ? product.variants.filter(v => v.available && v.option1 === 'Classic' && ['White','Grey','Khaki'].includes(v.option2)) : product.variants;
    const variants = isBack || isArms ? ['White','Grey','Khaki'].flatMap(color => allowed.filter(v => (isBack ? v.option2 : v.option1).replace('Gray','Grey') === color)) : allowed;
    variants.forEach(variant => {
      const option = node('option', '', isBack ? variant.option2 : isArms ? variant.option1.replace('Gray','Grey') : variant.title);
      option.value = variant.id; option.disabled = !variant.available; select.appendChild(option);
    });
    const first = variants.find(v => v.available) || variants[0];
    if (!first) return null;
    select.value = first.id;
    content.appendChild(select);
    const add = node('button', '', text.add); add.type = 'button'; content.appendChild(add);
    const error = node('p', 'op-coverage-cart__error'); error.hidden = true; error.setAttribute('role', 'alert'); content.appendChild(error);
    const chosen = () => variants.find(v => String(v.id) === select.value);
    function sync() {
      const variant = chosen();
      image.src = variant.featured_image?.src || product.featured_image;
      image.alt = title + ' — ' + select.selectedOptions[0].textContent;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(variant.price / 100);
      add.disabled = !variant.available;
      setText(add, variant.available ? text.add : text.soldOut);
    }
    select.addEventListener('change', sync);
    add.addEventListener('click', async () => {
      if (add.disabled) return;
      add.disabled = true; setText(add, text.adding); error.hidden = true;
      try {
        const response = await fetch(route + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: chosen().id, quantity: 1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || text.cartError);
        if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
        schedule();
      } catch (problem) { error.hidden = false; setText(error, problem.message); }
      finally { sync(); }
    });
    sync(); article.appendChild(content); return article;
  }
  let drawer;
  let observer;
  let timer;
  let pending = false;
  let lastSignature = '';
  function schedule() { clearTimeout(timer); timer = setTimeout(refreshCart, 200); }
  async function refreshCart() {
    if (pending || !drawer?.isConnected) return;
    const body = drawer.querySelector('.upcart-cart-body');
    if (!body) return;
    pending = true;
    try {
      const response = await fetch(route + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      const context = cartContext(cart);
      body.classList.toggle('op-coverage-cart-active', context.eligible);
      let section = drawer.querySelector('[data-op-coverage-cart]');
      if (!context.eligible) { if (section) section.remove(); lastSignature = ''; return; }
      const signature = JSON.stringify([cart.currency, context.full, context.hasBack, context.hasArms]);
      if (section && signature === lastSignature) return;
      const products = await catalog();
      const list = products.filter(product => {
        if (Number(product.id) === settings.backId) return !context.full && !context.hasBack;
        if (Number(product.id) === settings.armsId) return !context.full && !context.hasArms;
        return true;
      });
      const next = node('section', 'op-coverage-cart'); next.dataset.opCoverageCart = '';
      next.setAttribute('aria-label', context.full ? text.alsoAdd : text.reminder);
      next.appendChild(node('h3', '', context.full ? text.alsoAdd : text.reminder));
      list.forEach(product => { const item = card(product, cart.currency); if (item) next.appendChild(item); });
      if (section) section.replaceWith(next); else body.appendChild(next);
      lastSignature = signature;
    } catch (error) { console.warn('Couch accessory offers could not load.', error); }
    finally { pending = false; }
  }
  function attachCart() {
    const host = document.getElementById('upCart') || document.querySelector('.upcart-cart');
    const next = host?.shadowRoot || host;
    if (!next || next === drawer) return;
    if (observer) observer.disconnect();
    drawer = next;
    if (!drawer.querySelector('[data-op-coverage-cart-styles]')) {
      const style = node('style');
      style.dataset.opCoverageCartStyles = '';
      style.textContent = cartStyles;
      drawer.appendChild(style);
    }
    observer = new MutationObserver(mutations => {
      if (mutations.some(mutation => !mutation.target.closest?.('[data-op-coverage-cart]'))) schedule();
    });
    observer.observe(drawer, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']});
    schedule();
  }
  function boot() {
    document.querySelectorAll('[data-op-pd]').forEach(initCoverage);
    attachCart();
    new MutationObserver(attachCart).observe(document.body, {childList: true});
    let attempts = 0;
    const cartTimer = setInterval(() => {
      attachCart();
      if (document.getElementById('upCart')?.shadowRoot || ++attempts > 150) clearInterval(cartTimer);
    }, 200);
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => queueMicrotask(boot)); else queueMicrotask(boot);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-op-pd]').forEach(initCoverage));
  document.addEventListener('op:coverage-cart-changed', schedule);
})();
